import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

let activeRequests = 0;

export const loadingInterceptor: HttpInterceptorFn = (request, next) => {
  const loadingService = inject(LoadingService);

  activeRequests++;
  if (activeRequests === 1) {
    loadingService.show();
  }

  return next(request).pipe(
    finalize(() => {
      activeRequests = Math.max(activeRequests - 1, 0);
      if (activeRequests === 0) {
        loadingService.hide();
      }
    })
  );
};
